/** Polkadot チェーンごとに実行中の解析処理を保持する。 */
const runningAnalysisMap = new Map<number, Promise<void>>()

type AcquirePolkadotChainAnalysisLockParameters = {
  readonly chainId: number
}

/**
 * 同一 Polkadot チェーンの解析ロックを取得する。
 *
 * @param params - チェーン ID
 * @returns 解析ロックを解放する関数
 */
export const acquirePolkadotChainAnalysisLock = async ({
  chainId,
}: AcquirePolkadotChainAnalysisLockParameters): Promise<() => void> => {
  while (true) {
    const runningAnalysis = runningAnalysisMap.get(chainId)
    if (runningAnalysis === undefined) {
      break
    }
    await runningAnalysis
  }

  const { promise, resolve } = Promise.withResolvers<void>()
  runningAnalysisMap.set(chainId, promise)
  let released = false
  return () => {
    if (released) {
      return
    }
    released = true
    if (runningAnalysisMap.get(chainId) === promise) {
      runningAnalysisMap.delete(chainId)
    }
    resolve()
  }
}
